import React from 'react'
import { connect } from 'react-redux'
import UsersIndex from './UsersIndex'

import { set_path } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedSystemUsers extends React.Component {
  componentWillMount() {
    this.props.setPath('systemusers') // change depending on component
  }

  render() {
    return <UsersIndex header="System Users" userbase="system" />
  }
}

const SystemUsers = connect(mapStateToProps, mapDispatchToProps)(ConnectedSystemUsers)

export default SystemUsers



// WEBPACK FOOTER //
// ./src/js/components/SystemUsers.js